<template>
  <div class="form-box" v-loading="payLoading">
    <div class="form-title">
      <span class="go-back go-pc-show" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回提交页
      </span>
      <span class="go-back go-h5-show" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </span>
      <h1>确认订单</h1>
    </div>
    <div class="form-list">

      <div class="form-search radio-pc-show">
        <div class="order-header">
          <span class="title">提交信息：</span>
          <ul>
            <li>{{ orderDetail.title }}</li>
            <li class="span-tip">
              <span>{{ docName }}</span>
              <span v-if="modelName">{{ modelName }}</span>
              <span v-if="WordsNum">{{ orderDetail.extParam.creationWordsNum }}字左右</span>
            </li>
          </ul>
        </div>
        <div class="order-content">
          <span class="title">生成内容：</span>
          <div class="content-box">
            <div class="list-cont">
              <p>{{ docName }} - {{ orderDetail.title }} x1</p>
              <span>封面 | 摘要 | 目录 | 正文 | 致谢 | 参考文献</span>
              <span class="color">重复率不足15%</span>
              <el-button class="list-btn"
                         type="text"
                         icon="el-icon-document"
                         @click="openWord">查看示例文档</el-button>
            </div>
            <div class="list-tip" v-if="packData && packData.length > 0">
              <p v-for="item in packData">
                <span>{{ item.name }}</span>
                <span class="pack-txt">x{{ item.num }}</span>
                <span class="pack-txt" v-html="item.description"></span>
                <!--                <span class="color" @click="openLook(item.icon)">样例查看</span>-->
                <el-button class="list-btn"
                           type="text"
                           icon="el-icon-document"
                           @click="openLook(item.icon)">样例查看</el-button>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="form-info radio-h5-show">
        <div class="info-h5-item">
          <div class="tit">提交信息</div>
          <div class="info-h5-cont">
            <div class="t">{{ orderDetail.title }}</div>
            <div class="c1">
              <span>{{ docName }}</span>
              <span v-if="modelName">{{ modelName }}</span>
              <span v-if="WordsNum">{{ orderDetail.extParam.creationWordsNum }}字左右</span>
            </div>
          </div>
        </div>
        <div class="info-h5-item">
          <div class="tit">生成内容</div>
          <div class="info-h5-cont">
            <div class="t">{{ docName }} - {{ orderDetail.title }} x1</div>
            <div class="c2">
              <span>导语 | 封面 | 摘要 | 目录 | 正文</span>
              <span class="color">重复率不足15%</span>
            </div>
            <el-button class="list-btn"
                       type="text"
                       icon="el-icon-document"
                       @click="openWord">查看示例文档</el-button>
          </div>
        </div>
        <div class="info-h5-item">
          <div class="info-h5-cont b-top">
            <p v-for="item in packData">
              <span class="a">{{ item.name }} x{{ item.num }}</span>
              <span class="b" v-html="item.description"></span>
              <span class="c" @click="openLook(item.icon)">样例</span>
            </p>
          </div>
        </div>

      </div>

      <div class="pay-box" v-if="addServicesList.length > 0">
        <div class="pay-title">
          <img alt="" src="@/assets/images/icon/added.png" />
          <h3>附加服务</h3>
        </div>
        <div class="added-box">
          <el-checkbox-group v-model="checkList" @change="handleCheckboxChange">
            <el-checkbox border class="added-list" v-for="item in addServicesList" :label="item.id">
              <span class="name">{{ item.name }}</span>
              <span class="price">{{ item.price }} 元</span>
              <span class="show-price">{{ item.showPrice }} 元</span>
              <span class="hot-tag">限时特惠</span>

              <div class="added-list-box" v-if="item.icon">
                <div class="added-list-img">
                  <img :src="item.icon" alt="">
                </div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div class="pay-box">
        <div class="pay-title" v-if="!payBtn">
          <img alt="" src="@/assets/images/icon/order.png" />
          <h3 class="pay-title-pc">支付订单</h3>
          <h3 class="pay-title-h5">支付方式</h3>
        </div>
        <div class="pay-cont pay-pc-show">
          <div class="pay-img" v-if="!payBtn">
            <div v-if="orderDetail.qrCode">
              <generateQRCode :url="orderDetail.qrCode"></generateQRCode>
            </div>
          </div>
          <div class="pay-text">
            <div class="txt-tip">
              {{ docName }}
              <span v-if="WordsNum">({{ orderDetail.extParam.creationWordsNum }})</span>
              <span v-if="modelName">- {{ modelName }}</span>
              : 单价：{{ orderDetail.onlyShowPrice }}元/篇
            </div>
            <div class="price-box">
              <div class="price-left">
                <div>
                  总金额：
                  <span>{{ orderDetail.price }}</span>
                  <span class="t">元</span>
                  <span class="ck">
                    <el-checkbox v-model="payChecked"
                                 :checked="payChecked"
                                 :text-color="'#3c3c3c'"
                                 @change="changeCheckbox">智慧豆抵扣</el-checkbox>
                    <span> {{ userSetInfo && userSetInfo.balance >= 0 ? userSetInfo.balance + '元' : '未登录' }}</span>
                  </span>
                  <div class="mx">
                    <i class="el-icon-document"></i>明细

                    <div class="popover-tip-box">
                      <div class="title" v-if="orderDetail">
                        <div>含 {{orderDetail && orderDetail.otherIds ? Number(orderDetail.otherIds.length) + 1 : '1'}} 件商品</div>
                        <div class="s">
                          合计
                          <span class="num">{{ orderDetail.price }}</span>
                          <span>元</span>
                        </div>
                      </div>
                      <div class="cont-item" v-if="orderDetail">
                        <div class="item-left">
                          <i class="el-icon-document"></i>
                          <span class="name">{{ docName }}</span>
                          <span class="yhj">
                        优惠价：<span class="num">{{orderDetail.onlyPrice}}</span>元
                      </span>
                        </div>
                        <div class="item-right">
                          小计：<span class="color">{{orderDetail.onlyPrice}}</span> 元
                          <span class="i-num">原价{{orderDetail.onlyShowPrice}}元</span>
                        </div>
                      </div>
                      <div class="cont-item"
                           v-if="filteredData && filteredData.length > 0"
                           v-for="item in filteredData">
                        <div class="item-left">
                          <i class="el-icon-document"></i>
                          <span class="name">{{ item.name }}</span>
                          <span class="yhj">附加服务</span>
                        </div>
                        <div class="item-right">
                          小计：<span class="color">{{ item.price }}</span> 元
                          <span class="i-num">原价{{ item.showPrice }}元</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="price-foot">
                  (
                  <span class="yj">原价：{{ orderDetail.showPrice }}元</span>
                  <span class="yh">共优惠{{ preferentialPrice }}元</span>
                  )
                  <span class="cz" v-if="userInfo.isLogin" @click="openRecharge">
                    <i class="qian16">￥</i>
                    充值越多越划算
                  </span>
                  <span class="cz" v-else @click="openLogin">
                    <i class="qian16">￥</i>
                    智慧豆支付更划算
                  </span>
                </div>
              </div>
            </div>
            <div class="pay-tip" v-if="!payBtn">
              <img alt="" src="@/assets/images/icon/wx-pay2.png">
              <img alt="" src="@/assets/images/icon/zfb-pay2.png">
              <p>使用微信、支付宝扫码支付<span>(扫码支付,请勿刷新页面)</span></p>
            </div>
            <div class="pay-btn2" v-if="payBtn">
              <el-button type="primary" @click="postBalancePay">立即支付</el-button>
            </div>
          </div>
        </div>

        <div class="pay-check pay-h5-show" v-if="!payBtn">
          <div v-if="!isWeChatBrowser()">
            <img alt="" src="@/assets/images/icon/zfb-pay2.png">
            <span>支付宝支付</span>
            <el-radio class="pay-radio" v-model="payMethod" label="1">{{ '' }}</el-radio>
          </div>
          <div>
            <img alt="" src="@/assets/images/icon/wx-pay2.png">
            <span>微信支付</span>
            <el-radio class="pay-radio" v-model="payMethod" label="2">{{ '' }}</el-radio>
          </div>
        </div>
      </div>

    </div>

    <div class="pay-btn">
      <div class="pay-txt">
        <div class="txt-h5-top">
          总金额
          <span>{{ orderDetail.price }}</span>元
          <span class="e">({{ orderDetail.showPrice }}元)</span>
          <span class="h5-mx" @click="showH5Drawer">明细</span>
        </div>
        <div class="txt-h5-ck">
          <el-checkbox v-model="payChecked"
                       :checked="payChecked"
                       :text-color="'#3c3c3c'"
                       @change="changeCheckbox">智慧豆抵扣</el-checkbox>
          <span class="txt-h5-p"> {{ userSetInfo && userSetInfo.balance >= 0 ? userSetInfo.balance + '元' : '未登录' }}</span>

          <span class="cz" v-if="userInfo.isLogin" @click="openRecharge">
            <i class="qian16">￥</i>
            充值越多越划算
          </span>
          <span class="cz" v-else @click="openLogin">
            <i class="qian16">￥</i>
            智慧豆支付更划算
          </span>
        </div>
      </div>
      <el-button type="primary" size="small" @click="openPay">确认支付</el-button>
    </div>

    <el-dialog
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      width="50%"
      class="el-dialog-h5"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center>
<!--      <div class="dialog-info">-->
<!--        <p class="tip"><i class="el-icon-warning-outline"></i>即将扫码支付，请勿刷新页面</p>-->
<!--        <p>支付完成后用订单号查询结果，请勿重复支付！</p>-->
<!--&lt;!&ndash;        <p class="color"><span>预计 15 分钟生成完成！</span></p>&ndash;&gt;-->
<!--      </div>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button type="primary" size="mini" @click="centerDialogVisible = false">确 定</el-button>-->
<!--      </span>-->
      <div class="dialog-info2-pc">
        <div class="info-l">
          <ul>
            <li class="title">《{{ orderDetail.title }}》</li>
            <li class="tip">
              <span>{{ docName }}</span>
              <span v-if="modelName">{{ modelName }}</span>
            </li>
          </ul>
          <div class="f-tip">内容即将生成</div>
          <div class="info-txt">
            <img src="@/assets/images/info-txt.jpg">
          </div>
        </div>
        <div class="info-r">
          <div class="info-r-txt">
            <p class="b">
              <svg class="icon"
                   viewBox="0 0 1024 1024"
                   version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5303"
                   width="30" height="30"><path fill="#f49a29" d="M600.631 757.016a30.104 30.104 0 0 0-7.432 0.944l-174.761 45.062c-13.278 3.082-21.909 15.912-19.759 29.372 1.592 12.563 11.383 25.362 26.895 25.362a29.984 29.984 0 0 0 7.491-1.003l174.702-45.003c13.278-3.082 21.909-15.912 19.759-29.373-1.593-12.621-11.324-25.361-26.895-25.361z m-41.759 94.252a25.835 25.835 0 0 0-14.804 5.013c-11.619 7.962-22.767 12.386-33.088 12.976h-1.357a45.727 45.727 0 0 1-20.054-5.898c-0.59-0.295-2.89-1.828-4.424-2.831-4.247-2.831-5.426-3.598-6.842-3.775a28.2 28.2 0 0 0-12.976-3.185 31.26 31.26 0 0 0-28.901 20.172c-3.362 9.732-0.177 19.582 8.493 26.482 19.582 15.394 42.466 23.592 66.059 23.592 21.587 0 42.997-6.901 61.871-19.936a27.956 27.956 0 0 0 10.97-32.263c-3.775-12.15-13.802-20.289-24.949-20.289v-0.058z m149.517-491.902A207.792 207.792 0 0 0 625.58 275.2a228.133 228.133 0 0 0-110.294-27.839c-33.383 0-66.943 7.078-97.142 20.466a222.66 222.66 0 0 0-81.394 61.222c-41.169 49.367-58.568 120.852-46.418 191.098 11.619 67.533 48.6 124.214 101.447 155.533a27.315 27.315 0 0 0 14.037 4.011 28.31 28.31 0 0 0 26.541-21.705c3.523-11.792-1.66-24.445-12.445-30.375-70.659-41.877-90.772-142.734-68.831-212.214 21.292-67.356 86.466-112.654 162.198-112.654 31.909 0 62.992 8.257 89.828 23.887 36.332 21.115 62.284 56.327 73.136 99.147a177.358 177.358 0 0 1-19.464 135.008c-9.614 15.748-22.059 30.316-34.091 44.354-7.727 8.965-15.748 18.284-23.003 27.898-12.386 16.515-16.161 34.209-19.877 51.255l-2.005 9.142-159.367 42.407c-13.333 3.19-21.933 16.142-19.7 29.667 1.651 12.445 11.324 25.126 26.718 25.126a29.837 29.837 0 0 0 7.668-1.062l124.332-33.088c4.6-1.239 9.142-2.359 13.448-3.421 34.032-8.375 60.868-15.04 63.994-64.171 1.121-17.34 15.984-33.619 29.137-47.834 3.362-3.716 6.547-7.137 9.437-10.617 15.807-18.461 35.448-43.587 47.893-73.254 26.306-62.638 21.646-132.884-12.976-197.763l0.002-0.058zM237.72 478.095c0-15.335-12.386-27.839-27.721-27.839h-54.027c-15.359 0-27.81 12.451-27.81 27.81 0 15.359 12.451 27.81 27.81 27.81h53.909c15.335 0 27.721-12.445 27.721-27.78h0.118z m628.974-27.839h-53.85c-15.359 0-27.81 12.451-27.81 27.81 0 15.359 12.451 27.81 27.81 27.81h53.85c15.359 0 27.81-12.451 27.81-27.81-0.001-15.359-12.451-27.81-27.81-27.81zM279.597 284.342c11.578 10.117 29.165 8.932 39.281-2.646 9.167-10.491 9.167-26.144 0-36.636l-38.102-38.22c-11.578-10.117-29.165-8.932-39.281 2.646-9.167 10.491-9.167 26.144 0 36.636l38.102 38.22z m465.596 387.506c-11.578-10.117-29.165-8.932-39.281 2.646-9.167 10.491-9.167 26.144 0 36.636l38.102 38.161c11.578 10.117 29.165 8.932 39.281-2.646 9.167-10.491 9.167-26.144 0-36.636l-38.102-38.161zM512.395 208.434c15.335 0 27.721-12.445 27.721-27.78v-53.968c-0.707-15.326-13.704-27.178-29.03-26.471-14.337 0.661-25.81 12.134-26.471 26.471v53.968c0 15.335 12.386 27.78 27.721 27.78h0.059zM318.878 671.848c-10.804-10.847-28.356-10.882-39.203-0.078l-0.078 0.078-38.102 38.161c-10.847 10.847-10.847 28.434 0 39.281 10.847 10.847 28.434 10.847 39.281 0l38.102-38.102c10.852-10.868 10.852-28.472 0-39.34z m387.034-387.506c10.804 10.847 28.356 10.882 39.203 0.078l0.078-0.078 38.102-38.161c10.847-10.847 10.847-28.434 0-39.281-10.847-10.847-28.434-10.847-39.281 0l-38.102 38.102c-10.852 10.869-10.852 28.472 0 39.34z" p-id="5304"></path></svg>
              <span>温馨提示：</span>
            </p>
            <p v-for="(item,index) in dialogTxt">
              <span class="left">{{index + 1}}.</span>
              {{item}}
            </p>
          </div>
        </div>
        <div class="close-icon" @click="centerDialogVisible = false">
          <i class="el-icon-circle-close"></i>
        </div>
      </div>
      <div style="text-align:center">
        <el-button type="primary" size="mini" @click="centerDialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="lookImgVisible"
      :closed="closelookImg"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      class="lookVisible"
      title="样例查看"
      center>
      <div class="look-img">
        <img :src="lookImg" alt="">
      </div>
    </el-dialog>

    <el-drawer
      :visible.sync="detailedDrawer"
      :with-header="false"
      class="custom-drawer"
      :direction="'btt'">
      <div class="popover-tip-box">
        <div class="title" v-if="orderDetail">
          <div>含 {{orderDetail && orderDetail.otherIds ? Number(orderDetail.otherIds.length) + 1 : '1'}} 件商品</div>
          <div class="s">
            合计
            <span class="num">{{ orderDetail.price }}</span>
            <span>元</span>
          </div>
        </div>
        <div class="cont-item" v-if="orderDetail">
          <div class="item-left">
            <i class="el-icon-document"></i>
            <span class="name">{{ docName }}</span>
            <span class="yhj">
                        优惠价：<span class="num">{{orderDetail.onlyPrice}}</span>元
                      </span>
          </div>
          <div class="item-right">
            小计：<span class="color">{{orderDetail.onlyPrice}}</span> 元
            <span class="i-num">原价{{orderDetail.onlyShowPrice}}元</span>
          </div>
        </div>
        <div class="cont-item"
             v-if="filteredData && filteredData.length > 0"
             v-for="item in filteredData">
          <div class="item-left">
            <i class="el-icon-document"></i>
            <span class="name">{{ item.name }}</span>
            <span class="yhj">附加服务</span>
          </div>
          <div class="item-right">
            小计：<span class="color">{{ item.price }}</span> 元
            <span class="i-num">原价{{ item.showPrice }}元</span>
          </div>
        </div>
      </div>
    </el-drawer>

    <ExampleDocument ref="example"></ExampleDocument>
    <WalletBalance ref="Wallet" @userSetInfo="getUserSetInfo"></WalletBalance>
    <Login ref="showLogin"/>
    <Intercept ref="interceptDialog"
               :otherIdsLength="checkList.length"
               :otherIdsPrice="otherIdsPrice.toFixed(2)"
               @infoInterceptValue="infoInterceptValue"/>

  </div>
</template>

<script>
import CommonApi from '@/api/common'
import generateQRCode from '@/components/generateQRCode/generateQRCode.vue'
import RequestlogApi from '@/api/requestlog'
import ExampleDocument from '@/components/ExampleDocument/index.vue'
import WalletBalance from "@/components/walletBalance/index.vue"
import Login from "@/components/login/login.vue"
import UserPromotApi from "@/api/user"
import { EventBus } from "@/utils/eventBus"
import Intercept from "./components/intercept/index.vue"

export default {
  components: {
    Login,
    WalletBalance,
    generateQRCode,
    ExampleDocument,
    Intercept
  },
  data() {
    return {
      payLoading: false,
      orderDetail: '',
      creationDoc: '',
      modelCode: '',
      docName: '',
      modelName: '',
      WordsNum: false,
      storageAddServerInfo: '',
      addServicesList: [],
      addServicesData: [],
      checkList: [],
      packData: [],
      orderId: '',
      centerDialogVisible: false,
      payMethod: '1',
      windowWidth: document.body.clientWidth,
      isMobile: false,
      lookImg: '',
      lookImgVisible: false,
      shake: false,
      filteredData: [],
      payMethod2: '1',
      userInfo: {
        isLogin: false,
        username: '',
        nickname: '',
        token: ''
      },
      userSetInfo: '',
      payChecked: false,
      payBtn: false,
      detailedDrawer: false,
      dialogTxt: [
        '为了方便您后续使用，建议【Ctrl + D】收藏本站，方便下次直接访问。',
        '文档在付费后会进行内容生成创作，完成后页面会提示下载。',
        '在订单查询页面通过支付单号查询订单，支付单号可根据查询页面引导图查找。',
        '如果有附加服务《正文图表数据插件》建议勾选，会让内容更加充实。',
        '如果有附加服务《AI无限改稿》建议勾选，在生成完成后，可在内容优化界面进行内容优化：降重、润色、扩写等。',
        '使用过程中如有问题可以联系客服反馈，客服联系方式在网站右下角。'
      ],
      interceptValue: false
    }
  },
  created() {
    this.isMobile = this.windowWidth < 901
    if (!this.isMobile) {
      this.centerDialogVisible = true
    }
    this.report()
    if (localStorage.getItem('userInfo')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
    if (localStorage.getItem('userSetInfo')) {
      this.userSetInfo = JSON.parse(localStorage.getItem('userSetInfo'))
    }
  },
  beforeRouteLeave(to, from, next) {
    if(this.isMobile) {
      return next();
    }
    if(!this.interceptValue){
      next(false);
      this.interceptValue = true
      this.postDetainment()
    } else {
      // 允许导航
      next();
    }
    // if (this.postDetainment()) {
    //   // 阻止导航
    //   next(false);
    // } else {
    //   console.log('1111')
    //   // 允许导航
    //   next();
    // }
  },
  beforeDestroy() {
    //清除定时器查询
    clearInterval(this.timer)
  },
  computed: {
    preferentialPrice(){
      let num = this.orderDetail.showPrice - this.orderDetail.price
      num = num.toFixed(2)
      return num
    },
    otherIdsPrice(){
      if(this.filteredData.length > 0){
        return this.filteredData.reduce((sum, item) => {
          return sum + item.price
        }, 0);
      }else {
        return 0
      }
    }
  },
  mounted() {
    EventBus.$on("userLogin", (msg) => {
      // 登录成功发送来的消息
      if(msg === 'userLoginTrue'){
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.userSetInfo = JSON.parse(localStorage.getItem('userSetInfo'))
      }
    })
    EventBus.$on("userOutLogin", (msg) => {
      // 退出登录发送来的消息
      if(msg === 'userOutLoginTrue'){
        this.userInfo = this.$options.data().userInfo
        this.userSetInfo = ''
      }
    })
    let orderInfo = ''
    this.orderId = localStorage.getItem('orderId')
    if (this.orderId) {
      return this.postQueryOrderDetail(this.orderId)
    } else if (this.$route.params) {
      orderInfo = this.$route.params
    }
    // 存储附加服务所需参数
    // this.addServicesData = {
    //   creationDocCode: orderInfo.creationDocCode,
    //   creationDocId: orderInfo.creationDocId,
    //   extParam: orderInfo.extParam
    // }
    // this.storageAddServerInfo = orderInfo
    if (orderInfo.info) {
      localStorage.setItem('creationDocCode', orderInfo.creationDocCode)
      localStorage.setItem('orderId', orderInfo.info)
      this.orderId = localStorage.getItem('orderId')
      this.postQueryOrderDetail(orderInfo.info)
    }
  },
  methods: {
    infoInterceptValue(type){
      this.interceptValue = type
    },
    report() {
      let data = {
        type: 2,
        channelCode: '',
        description: ''
      }
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      RequestlogApi.report(data, key, time, infoMd5).then(res => {
      }).catch(() => {
      })
    },
    handleCheckboxChange(value) {
      let _this = this
      if(_this.shake === true){
        return
      }
      _this.shake = true
      //清除定时器查询
      clearInterval(_this.timer)
      // let data = this.storageAddServerInfo
      // delete data.info
      // data.otherIds = this.checkList
      let data = {
        creationDocCode: localStorage.getItem('creationDocCode'),
        id: localStorage.getItem('orderId'),
        otherIds: _this.checkList
      }
      this.updateOrder(data)
    },
    // 添加附加服务 - 修改订单
    updateOrder(dto) {
      let _this = this
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = this.$md5(setOf)
      CommonApi.updateOrder(dto, key, time, infoMd5).then(res => {
        let data = res.data
        localStorage.setItem('orderId', data.id)
        _this.postQueryOrderDetail(data.id)
      }).catch(() => {
      })
    },
    // 查询订单信息
    postQueryOrderDetail(id) {
      let _this = this
      _this.payLoading = true
      CommonApi.queryOrderDetail(id).then(res => {
        // 存储附加服务所需参数
        _this.addServicesData = {
          creationDocCode: localStorage.getItem('creationDocCode'),
          creationDocId: res.data.creationDocId,
          extParam: res.data.extParam
        }
        _this.orderDetail = res.data
        // 执行参数格式转换
        _this.orderDetail.extParam = JSON.parse(_this.orderDetail.extParam)
        _this.WordsNum = !!_this.orderDetail.extParam.creationWordsNum
        // 如果支付金额为 0 显示支付按钮
        _this.payBtn = Number(_this.orderDetail.price) === 0;
        // 显示勾选抵扣的按钮 isUseXyDou
        if(_this.orderDetail.isUseXyDou){
          _this.payChecked = true
        }
        _this.getCreationDoc()
        _this.getModelCode()
        // 获取附加服务
        _this.getOtherServer(_this.addServicesData)
        // 获取资料包
        _this.getDataPack(_this.addServicesData.creationDocId)
        // 关闭防抖
        _this.shake = false
        //有订单，启动定时器
        _this.payLoading = false
        _this.getTimeFun(id)
      }).catch(() => {
      })
    },
    // 获取组稿类型
    getCreationDoc() {
      let _this = this
      CommonApi.getCreationDoc().then(res => {
        _this.creationDoc = res.data
        _this.creationDoc.forEach(item => {
          if (item.id === _this.orderDetail.creationDocId) {
            _this.docName = item.name
          }
        })
        // if (_this.docName !== '毕业论文'){
        //   _this.dialogTxt.splice(3,3)
        // }
      }).catch(() => {
      })
    },
    // 获取模型
    getModelCode() {
      let _this = this
      CommonApi.getModelCode().then(res => {
        _this.modelCode = res.data
        _this.modelCode.forEach(item => {
          if (item.value === _this.orderDetail.extParam.modelCode) {
            _this.modelName = item.label
          }
        })
      }).catch(() => {
      })
    },
    // 获取附加服务
    getOtherServer(data) {
      let _this = this
      CommonApi.getOtherServer(data).then(res => {
        _this.addServicesList = res.data
        let array = _this.addServicesList.map(item => {
          return item.id
        })
        if (_this.orderDetail.otherIds.length > 0) {
          let array2 = _this.orderDetail.otherIds.map(item => {
            return item.toString()
          })
          _this.checkList = array2.filter(item => array.includes(item))
        }
        // 保存明细
        _this.filteredData = _this.addServicesList.filter(item => _this.checkList.includes(item.id));
      }).catch(() => {
      })
    },
    // 获取资料包
    getDataPack(id) {
      let _this = this
      CommonApi.getDataPack(id).then(res => {
        _this.packData = res.data.datas
      }).catch(() => {
      })
    },
    // 查询订单支付状态
    getQueryPayState(orderId) {
      let _this = this
      CommonApi.queryPayState(orderId).then(res => {
        // _this.orderCont = res.data
        if (res.data) {
          // 修改挽留状态
          _this.interceptValue = true
          //清除定时器查询
          clearInterval(_this.timer)
          //清除缓存订单查询号
          localStorage.removeItem('orderId')
          localStorage.removeItem('creationDocCode')
          //跳转传参
          _this.$router.push({ path: _this.paySuccessUrl + '?info=' + orderId })
        }
      }).catch(() => {
      })
    },
    //定时器查询订单状态
    getTimeFun(id) {
      this.timer = setInterval(() => {
        this.getQueryPayState(id)
      }, 3000)
    },
    goBack() {
      //清除缓存订单查询号
      // localStorage.removeItem('orderId')
      // localStorage.removeItem('creationDocCode')
      // 后退到上个页面
      this.$router.go(-1)
    },
    // 移动端 调取支付
    openPay() {
      let _this = this
      // let order = localStorage.getItem('orderId')

      if(_this.payBtn){
        return _this.postBalancePay()
      }
      if (this.isWeChatBrowser()) {
        window.location.href = `/prod-admin-api/paper/api/public/pay/${_this.orderDetail.id}`
      } else {
        if (_this.payMethod == 1) {
          // 支付宝支付
          window.location.href = `/prod-admin-api/paper/api/public/h5/pay/${_this.orderDetail.id}/1`
        } else {
          // 微信支付
          window.location.href = `/prod-admin-api/paper/api/public/h5/pay/${_this.orderDetail.id}/2`
        }
      }
    },
    // 判断是否是微信浏览器
    isWeChatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase()
      const isWx = /micromessenger/.test(userAgent)
      if (isWx) {
        this.payMethod = '2'
      }
      return isWx
    },
    openWord(){
      CommonApi.example(this.addServicesData.creationDocId).then(res => {
        if(res.data && res.data.length > 0) {
          this.$refs.example.openDialog(res.data)
        }else {
          this.$message.info('暂无示例！')
        }
      }).catch(() => {
      })
    },
    // 样例查看
    openLook(url){
      this.lookImg = url
      setTimeout(()=>{
        this.lookImgVisible = true
      },200)
    },
    closelookImg(){
      this.lookImg = ''
    },
    changeCheckbox(e){
      let _this = this
      if(!_this.userInfo.isLogin){
        _this.payChecked = false
        _this.openLogin()
      }else {
        // 清除定时器
        // clearInterval(_this.timer)
        // 做抵扣金额的操作
        let data = {
          id: _this.orderDetail.id,
          use: e
        }
        _this.postUserXydou(data)
      }
    },
    openRecharge(){
      if(this.userInfo.token){
        // 清除定时器
        clearInterval(this.timer)
        let info = {
          close: true
        }
        this.$emit('downloadOffWay',info)
        // this.handleClose()
        this.$refs.Wallet.getXydouList(this.userInfo.token,this.userSetInfo.balance)
      }else {
        this.$message.warning('请先登录！')
        this.openLogin()
      }
    },
    openLogin(){
      this.$refs.showLogin.openLogin()
    },
    // acceptInfo(msg){
    //   this.userInfo = msg
    //   if(this.userInfo.isLogin){
    //     this.getUserDetailVo()
    //   }
    //   // this.$emit('downloadUserLogin',true)
    // },
    getUserSetInfo(args){
      if(args === true){
        this.getUserDetailVo()
      }
    },
    getUserDetailVo(){
      UserPromotApi.getUserDetailVo(this.userInfo.token).then(res => {
        this.userSetInfo = res.data
        localStorage.setItem('userSetInfo', JSON.stringify(res.data))
      }).catch(() => {
      })
    },
    postBalancePay(){
      let _this = this
      let orderId = localStorage.getItem('orderId')
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = _this.$md5(setOf)
      CommonApi.postBalancePay(_this.orderDetail.id,_this.userInfo.token,key,time,infoMd5).then(res => {
        _this.$message.success('支付成功')
        // 修改挽留状态
        _this.interceptValue = true
        clearInterval(_this.timer)
        //跳转传参
        _this.$router.push({ path: _this.paySuccessUrl + '?info=' + orderId })
        //清除缓存订单查询号
        localStorage.removeItem('orderId')
        localStorage.removeItem('creationDocCode')
      }).catch(() => {
      })
    },
    postUserXydou(data){
      let _this = this
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = _this.$md5(setOf)
      CommonApi.postUserXydou(data,_this.userInfo.token,key,time,infoMd5).then(res => {
        // 清除定时器
        clearInterval(_this.timer)
        // console.log(res.data)
        _this.postQueryOrderDetail(data.id)
      }).catch(() => {
        _this.payChecked = false
      })
    },
    // 打开H5明细
    showH5Drawer(){
      this.detailedDrawer = true
    },
    // 客户挽留
    someInstance(){
      if(!this.orderId) return false

    },
    postDetainment(){
      if(!this.orderId) return false

      let _this = this
      let time = new Date().getTime()
      let key = localStorage.getItem('key')
      let ticket = localStorage.getItem('ticket')
      let setOf = ticket + time + ticket + ticket + time + ticket
      let infoMd5 = _this.$md5(setOf)

      CommonApi.postDetainment(_this.orderId, key, time, infoMd5).then(res => {
        if(res.data.detainment){
          _this.interceptValue = res.data.detainment
        }else {
          _this.interceptValue = true
        }
        if(res.data.detainment){
          _this.$refs.interceptDialog.openIntercept(res.data,_this.addServicesData.creationDocId)
        }
      }).catch(()=>{
        _this.interceptValue = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.form-box {
  position: relative;
  width: 100%;
  min-height: 770px;

  .form-title {
    position: relative;
    width: 100%;
    height: 76px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    h1 {
      position: relative;
      z-index: 1;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }
    h1::before {
      content: '';
      z-index: -1;
      position: absolute;
      bottom: -2px;
      left: 50%;
      width: 104px;
      height: 12px;
      margin-left: -52px;
      background-color: rgba(42, 171, 255, 0.3);
    }

    .go-back {
      position: absolute;
      left: 20px;
      line-height: 20px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      i {
        font-size: 20px;
      }
    }

    .go-pc-show {
      display: flex;
    }

    .go-h5-show {
      display: none;
    }
  }

  .form-list {
    //width: 100%;
    //margin: 0 auto;
    //padding: 30px 5%;
    //height: 694px;
    //overflow: auto;
    width: 80%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 10px 0;

    .form-search {
      background: rgb(255, 255, 255);
      box-shadow: rgba(0, 0, 0, 0.06) 0 2px 8px 1px;
      border-radius: 8px;
      border: 1px solid rgb(228, 229, 231);
      overflow: hidden;
      padding: 0;

      .order-header{
        width: 100%;
        height: max-content;
        min-height: 50px;
        color: rgb(102, 102, 102);
        background: rgb(249, 249, 249);
        border-radius: 15px 15px 0 0;
        padding: 15px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        .title{
          line-height: 24px;
          font-size: 12px;
        }
        ul{
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          justify-content: flex-start;
          li{
            height: 24px;
            line-height: 24px;
            font-size: 14px;
            color: #333333;
          }
          li.span-tip {
            span {
              height: 24px;
              line-height: 24px;
              padding: 3px 5px;
              margin-left: 10px;
              font-size: 11px;
              font-weight: normal;
              color: #ffffff;
              border-radius: 3px;
            }
            span:nth-child(1) {
              background-color: #409EFF;
            }
            span:nth-child(2) {
              background-color: #67C23A;
            }
            span:nth-child(3) {
              background-color: #E6A23C;
            }
          }
        }
      }
      .order-content{
        position: relative;
        width: 100%;
        padding: 15px 20px 15px 85px;
        display: flex;
        justify-content: flex-start;
        .title{
          margin-left: -66px;
          line-height: 24px;
          font-size: 12px;
          color: rgb(102, 102, 102);
        }
        .content-box{
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          .list-cont{
            min-height: 40px;
            color: rgb(102, 102, 102);
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
            p{
              line-height: 24px;
              font-size: 14px;
              color: #333333;
            }
            span{
              height: 24px;
              line-height: 24px;
              margin-left: 16px;
              font-size: 12px;
              font-weight: normal;
              color: #b2b5ba;
            }
            span.color{
              padding: 0 5px;
              margin-top: 2px;
              height: 18px;
              line-height: 18px;
              color: #ff3434;
              font-size: 11px;
              font-weight: bold;
              border: 1px solid #ffdaba;
              border-radius: 4px;
            }
            .list-btn{
              margin: 4px 0 0 16px;
              padding: 0;
              /deep/ span{
                font-size: 12px !important;
              }
            }
          }
          .list-tip{
            width: 100%;
            padding: 10px 0;
            border-top: 1px solid #eeeeee;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            p{
              width: 50%;
              min-height: 30px;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;
              span {
                font-size: 14px;
                color: #333;
              }
              span.pack-txt {
                margin-left: 10px;
                font-size: 12px;
                color: rgb(178, 181, 186);
              }
              span.color{
                padding: 0 5px;
                margin-left: 12px;
                height: 18px;
                line-height: 18px;
                color: #ffffff;
                font-size: 11px;
                background-color: #409EFF;
                border-radius: 4px;
                cursor: pointer;
              }
              .list-btn{
                margin: 4px 0 0 16px;
                padding: 0;
                /deep/ span{
                  font-size: 12px !important;
                }
              }
            }
          }
        }
      }
    }

    .pay-box {
      padding-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      .pay-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        img {
          width: 28px;
          height: 28px;
          margin-right: 10px;
        }

        h3 {
          font-size: 18px;
          font-weight: bold;
        }
        .pay-title-pc{display: block;}
        .pay-title-h5{display: none;}
      }

      .pay-cont {
        padding-top: 20px;
        //margin: 0 auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        .pay-img {
          position: relative;
          border-radius: 15px;
          border: none;

          > div {
            padding: 10px;
            border: 1px solid #e6e6e6;

            img {
              width: 124px;
              height: 124px;
              padding: 0;
              margin: 0;
              border: 0;
              background-color: #ffffff;
            }
          }

          > div:before, > div:after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
          }

          > div:before {
            bottom: 0;
            left: 0;
            border-bottom: 2px solid #36b7e6;
            border-left: 2px solid #36b7e6;
          }

          > div:after {
            bottom: 0;
            right: 0;
            border-bottom: 2px solid #36b7e6;
            border-right: 2px solid #36b7e6;
          }
        }

        .pay-img:before,
        .pay-img:after {
          content: '';
          position: absolute;
          width: 10px;
          height: 10px;
        }

        .pay-img:before {
          top: 0;
          left: 0;
          border-top: 2px solid #36b7e6;
          border-left: 2px solid #36b7e6;
        }

        .pay-img:after {
          top: 0;
          right: 0;
          border-top: 2px solid #36b7e6;
          border-right: 2px solid #36b7e6;
        }

        .pay-text {
          padding-left: 30px;

          .txt-tip{
            margin-bottom: 10px;
          }

          .price-box {
            padding: 10px 0;
            display: flex;
            align-items: center;

            .price-left {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              > div {
                display: flex;
                flex-direction: row;
                align-items: center;
                > span {
                  font-size: 28px;
                  font-weight: bold;
                  color: #fc5151;
                }
                .t {
                  margin-right: 6px;
                  font-size: 16px;
                  font-weight: initial;
                }
                .ck{
                  margin-left: 6px;
                  line-height: 16px;
                  /deep/ .el-checkbox__label{
                    padding-left: 6px;
                  }
                  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
                    color: #3c3c3c;
                  }
                }
                .yj {
                  font-size: 14px;
                  color: #9ea2a9;
                  font-weight: initial;
                  font-style: italic;
                  text-decoration: line-through;
                }
                .yh {
                  margin-left: 6px;
                  font-size: 14px;
                  color: rgb(204, 126, 32);
                  font-weight: initial;
                }
                .cz{
                  margin: 0 8px;
                  font-size: 14px;
                  font-weight: initial;
                  color: #6e83f7;
                  cursor: pointer;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  .qian16{
                    display: block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    margin-right: 3px;
                    text-align: center;
                    border-radius: 20px;
                    border: 1px solid #6e83f7;
                    font-size: 14px;
                    color: #6e83f7;
                    font-style: initial;
                    text-decoration: none;
                  }
                }
                .cz:hover{
                  text-shadow: 0 0 5px rgba(60, 90, 251, 0.5);
                }
                .mx {
                  position: relative;
                  padding: 0 3px;
                  margin-top: 2px;
                  margin-left: 20px;
                  font-size: 14px;
                  color: #6e83f7;
                  border-radius: 3px;
                  border: 1px solid #dce1ff;
                  cursor: pointer;
                  .popover-tip-box {
                    position: absolute;
                    z-index: 99;
                    left: -240px;
                    bottom: 30px;
                    width: 500px;
                    min-height: 300px;
                    background-color: #ffffff;
                    box-shadow: 0 2px 8px 1px rgba(0, 0, 0, 0.1);
                    border-radius: 15px;
                    display: none;
                    .title {
                      display: flex;
                      width: 100%;
                      font-size: 14px;
                      color: #3c3c3c;
                      align-items: center;
                      justify-content: space-between;
                      padding: 16px 20px;
                      background: linear-gradient(180deg, #ebf1fc, #fff);
                      border-radius: 15px 15px 0 0;
                      .s {
                        span {
                          color: #ee6360;
                        }
                        span.num {
                          margin: 0 8px;
                          font-size: 20px;
                        }
                      }
                    }
                    .cont-item {
                      margin: 0 20px;
                      padding: 10px 0;
                      color: #3c3c3c;
                      border-bottom: 1px solid #f0f0f0;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: space-between;
                      .item-left {
                        padding-left: 30px;
                        .el-icon-document {
                          margin-left: -30px;
                        }
                        .name {
                          margin-left: 10px;
                          font-weight: bold;
                        }
                        .yhj {
                          margin-left: 5px;
                          font-size: 12px;
                          color: #b2b5ba;
                          .num {
                            margin-right: 5px;
                            font-size: 14px;
                            color: #3c3c3c;
                          }
                        }
                      }
                      .item-right {
                        font-size: 12px;
                        color: #b2b5ba;
                        .color {
                          font-size: 14px;
                          color: #ee6360;
                        }
                        .i-num {
                          font-size: 12px;
                          font-style: italic;
                          text-decoration: line-through;
                        }
                      }
                    }
                    .cont-item:last-child {
                      border-bottom: 0;
                    }
                  }
                }
                .mx:hover {
                  .popover-tip-box {
                    display: block;
                  }
                }
              }
              .price-foot{
                padding-top: 12px;
              }
            }
          }

          .pay-tip {
            margin-top: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            img {
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }

            p {
              span {
                font-size: 14px;
                color: #409EFF;
              }
            }
          }
          .pay-btn2{
            margin-top: 20px;
          }
        }
      }

      .added-box {
        .added-list {
          position: relative;
          box-sizing: border-box;
          height: 40px;
          line-height: 40px;
          background: linear-gradient(90deg, #eef9fe, #fcfeff);
          border-radius: 6px 6px 6px 6px;
          padding: 0 15px;
          margin: 20px 20px 0 0;
          border: 1px solid #abd0f6;
          cursor: pointer;

          .added-list-box{
            display: none;
            position: absolute;
            right: -100px;
            bottom: 38px;
            z-index: 99;
            width: 480px;
            height: 340px;
            padding: 0;
            border-radius: 15px;
            border: 2px solid #ffffff;
            background-color: #ffffff;
            box-shadow: 0 0 10px rgba(0,0,0,0.2);
            .added-list-img{
              height: 340px;
              overflow-y: auto;
              img{
                width: 100%;
                height: auto;
                border-radius: 15px;
              }
            }
          }
          .added-list-box::after{
            content: '';
            position: absolute;
            right: 50%;
            bottom: -8px;
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #ffffff;
          }
        }
        .added-list:hover{
          .added-list-box{
            display: block;
          }
        }

        span.name {
          margin-right: 10px;
        }

        span.price {
          margin-right: 10px;
          font-weight: bold;
          color: #fc5151;
        }

        span.show-price {
          font-size: 12px;
          color: #9c9c9c;
          text-decoration: line-through;
        }

        span.hot-tag{
          padding: 3px 6px;
          color: #f4753d;
          font-size: 12px;
          background-color: #fde9dd;
          border-radius: 4px;
          margin-left: 8px;
        }
      }

      .pay-pc-show {
        //display: block;
      }

      .pay-h5-show {
        display: none;
      }

    }

    .radio-pc-show {
      display: block;
    }

    .radio-h5-show {
      display: none;
    }
  }
}

/deep/ .el-dialog {
  position: relative;
  border-radius: 15px;

  .el-dialog__header {
    border-bottom: 1px solid #eaebee;
  }
}

.el-dialog-h5{
  /deep/ .el-dialog__header{
    display: none;
  }
  /deep/ .el-dialog__body{
    border-radius: 15px;
    background: linear-gradient(180deg, #ebf1fc, #fff);
  }
}

.dialog-info {
  display: none;
  padding-top: 10px;
  //display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    line-height: 30px;
    font-size: 15px;
    font-weight: bold;
    color: #999999;
  }

  p.tip {
    margin-bottom: 10px;
    font-size: 16px;
    color: #3c3c3c;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    i {
      margin-right: 10px;
      font-size: 20px;
      color: #f48321;
    }
  }
  p.color{
    span{
      font-size: 16px;
      color: #e31c1c;
    }
  }
}

.dialog-info2-pc{
  position: relative;
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  .info-l{
    position: relative;
    width: 260px;
    height: 380px;
    border-radius: 10px;
    border: 1px solid #c0c0c0;
    background-color: #ffffff;
    overflow: hidden;
    .f-tip{
      position: absolute;
      z-index: 9;
      top: 50%;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-weight: bold;
      color: #1c1c1c;
      background-color: rgba(255,255,255,0.8);
    }
    ul{
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      li{
        width: 100%;
        min-height: 24px;
        padding: 10px 0;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #333333;
        box-sizing: content-box;
      }
      li.title{
        font-size: 15px;
        font-weight: bold;
        border-bottom: 1px solid #e0e0e0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      li.tip {
        padding: 5px 0;
        span {
          height: 24px;
          line-height: 24px;
          padding: 3px 5px;
          margin-left: 10px;
          font-size: 11px;
          font-weight: normal;
          color: #ffffff;
          border-radius: 3px;
        }
        span:nth-child(1) {
          background-color: #409EFF;
        }
        span:nth-child(2) {
          background-color: #67C23A;
        }
        span:nth-child(3) {
          background-color: #E6A23C;
        }
      }
    }
    .info-txt{
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      img{
        width: 100%;
        height: auto;
        margin: 0;
      }
    }
  }
  .info-r{
    flex: 1;
    .info-r-txt{
      padding: 10px 0 0 40px;
      p{
        padding-left: 22px;
        margin-bottom: 15px;
        line-height: 24px;
        color: #1c1c1c;
        span.left{
          margin-left: -15px;
        }
      }
      p.b{
        padding-left: 0;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;
        span{
          margin-top: 5px;
          margin-left: 8px;
        }
      }
    }
  }
  .close-icon{
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    i{
      font-size: 30px;
      color: rgba(0,0,0,0.3);
    }
  }
}

.pay-btn {
  display: none;
}

.lookVisible{
  /deep/ .el-dialog{
    margin-top: 5vh !important;
    height: 85vh !important;
    .el-dialog__header{
      height: 56px !important;
      line-height: 56px !important;
      padding: 0 20px !important;
      .el-dialog__title{
        font-size: 16px !important;
      }
    }
    .el-dialog__body{
      height: calc(100% - 56px) !important;
      padding: 0 !important;
    }
  }
  .look-img{
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: auto;
    img{
      width: 90%;
    }
  }
}

@media screen and (max-width: 900px) {
  .lookVisible{
    /deep/ .el-dialog{
      width: 90%;
    }
  }
  .form-box {
    position: relative;
    height: 100%;

    .h5-show {
      display: none;
    }

    .form-title {
      height: 50px;
      h1{
        font-size: 18px;
      }

      .go-pc-show {
        display: none;
      }

      .go-h5-show {
        left: 10px;
        line-height: 18px;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }

    .form-list {
      width: 100%;
      height: auto;
      padding: 5px 5px 100px 5px;
      margin-top: 10px;
      background-color: rgba(255, 255, 255, 0.7);
      box-shadow: 0 2px 5px rgba(0, 85, 255, 0.1);
      border-radius: 10px;
      overflow: initial;

      .el-form-item {
        margin-bottom: 10px;
      }

      .radio-pc-show {
        display: none;
      }

      .radio-h5-show {
        display: block;
      }

      .form-info {
        background: #ffffff;
        box-shadow: 0 4px 12px 1px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        border: 1px solid #e4e5e7;

        .info-h5-item {
          .tit {
            position: relative;
            border-radius: 10px 10px 0 0;
            padding: 5px 20px;;
            background-color: #f9f9f9;
          }

          .tit::before {
            content: '';
            position: absolute;
            top: 9px;
            left: 10px;
            width: 3px;
            height: 12px;
            border-radius: 5px;
            background-color: #6e83f7;
          }

          .info-h5-cont {
            padding: 10px 20px;
            display: flex;
            flex-direction: column;

            .t {
              font-size: 14px;
            }

            .c1 {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;
              flex-wrap: wrap;

              span {
                height: 18px;
                line-height: 16px;
                border-radius: 3px;
                border: 1px solid #d8dadd;
                box-sizing: border-box;
                padding: 0 4px;
                margin: 5px 5px 0 0;
                font-size: 10px;
                color: #9c9c9c;
              }
            }

            .c2 {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;
              flex-wrap: wrap;

              span {
                height: 12px;
                line-height: 12px;
                box-sizing: border-box;
                margin: 5px 0 0 0;
                padding-right: 5px;
                font-size: 10px;
                color: #9c9c9c;
              }
              span.color{
                height: 16px;
                line-height: 16px;
                padding: 0 5px;
                color: #ff9a50;
                font-size: 10px;
                border: 1px solid #ffdaba;
                border-radius: 4px;
              }
            }
            /deep/ .list-btn{
              margin-left: auto;
              margin-top: 10px;
              padding: 0;
              i{
                font-size: 12px !important;
              }
              span{
                font-size: 10px !important;
              }
            }

            p {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;
              padding: 5px 0;
              .a {
                width: 35%;
                font-size: 10px;
                color: #3c3c3c;
              }
              .b {
                width: 50%;
                font-size: 10px;
                color: #9c9c9c;
              }
              .c{
                width: 15%;
                text-align: right;
                font-size: 10px;
                color: #6e83f7;
              }
            }
          }

          .b-top {
            margin: 0 20px;
            padding: 5px 0;
            border-top: 1px solid #d8dadd;
          }
        }
      }

      .pay-box {
        padding-top: 15px;

        .pay-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }

          h3 {
            font-size: 14px;
            font-weight: bold;
          }
          .pay-title-pc{display: none;}
          .pay-title-h5{display: block;}
        }

        .added-box {
          .el-checkbox-group {
            display: flex;
            flex-direction: row;
            align-content: center;
            justify-content: space-between;
            flex-wrap: wrap;
          }

          .added-list {
            position: relative;
            width: 48%;
            min-width: 108px;
            height: auto;
            min-height: 70px;
            box-sizing: border-box;
            background: linear-gradient(90deg, #eef9fe, #fcfeff);
            border-radius: 6px;
            padding: 10px 0;
            margin: 10px 0 0 0;
            border: 1px solid #abd0f6;
            cursor: pointer;

            /deep/ .el-checkbox__input {
              position: absolute;
              bottom: 5px;
              right: 5px;
            }

            /deep/ .el-checkbox__label {
              display: flex;
              flex-direction: row;
              align-content: center;
              justify-content: flex-start;
              flex-wrap: wrap;
            }

            span.name {
              width: 100%;
              min-height: 30px;
              line-height: 16px;
              font-size: 11px;
              white-space: pre-wrap;
            }

            span.price {
              margin-right: 5px;
              font-weight: bold;
              font-size: 12px;
              color: #fc5151;
            }

            span.show-price {
              font-size: 10px;
              color: #9c9c9c;
              text-decoration: line-through;
            }

            span.hot-tag {
              position: absolute;
              top: -7px;
              right: -1px;
              padding: 0 3px;
              font-size: 10px;
            }
          }
          .added-list:hover{
            .added-list-box{
              display: none;
            }
          }
        }

        .pay-pc-show {
          display: none;
        }

        .pay-h5-show {
          display: block;
        }

        .pay-check {
          width: 100%;
          margin-top: 10px;
          background-color: #ffffff;
          box-shadow: 0 4px 12px 1px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          border: 1px solid #e4e5e7;

          > div {
            width: 100%;
            padding: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;

            img {
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }

            span {
              font-size: 12px;
            }

            .pay-radio {
              margin-left: auto;
            }
          }

          > div:last-child {
            border-top: 1px solid #e4e5e7;
          }
        }
      }
    }

    .pay-btn {
      position: fixed;
      bottom: 0;
      left: 80px;
      //width: calc(100% - 80px);
      width: 100%;
      height: 60px;
      margin-left: -80px;
      z-index: 99;
      box-sizing: border-box;
      padding: 5px 10px;
      background-color: #ffffff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .pay-txt {
        font-size: 12px;
        color: #3c3c3c;

        .txt-h5-top{
          span {
            margin-right: 5px;
            font-size: 18px;
            font-weight: bold;
            color: #fc5151;
          }
          .e {
            font-size: 11px;
            color: #9c9c9c;
            text-decoration: line-through;
          }
          .h5-mx{
            position: relative;
            padding: 2px 5px;
            margin-left: 10px;
            font-size: 12px;
            color: #6e83f7;
            border-radius: 3px;
            border: 1px solid #dce1ff;
          }
        }
        .txt-h5-ck{
          margin-top: 5px;
          display: flex;
          flex-direction: row;
          align-items: center;
          line-height: 16px;
          /deep/ .el-checkbox__label{
            padding-left: 6px;
            font-size: 12px;
          }
          /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #3c3c3c;
          }
          .txt-h5-p{
            font-size: 12px;
            color: #fc5151;
          }
          .cz{
            margin: 0 8px;
            font-size: 10px;
            font-weight: initial;
            color: #6e83f7;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            .qian16{
              display: block;
              width: 14px;
              height: 14px;
              line-height: 12px;
              margin-right: 2px;
              text-align: center;
              border-radius: 14px;
              border: 1px solid #6e83f7;
              font-size: 11px;
              color: #6e83f7;
              font-style: initial;
              text-decoration: none;
            }
          }
        }

      }
    }

    .el-dialog-h5 {
      /deep/ .el-dialog {
        width: 90% !important;
      }
    }

    .custom-drawer{
      /deep/ .el-drawer{
        border-radius: 15px 15px 0 0;
        height: 50% !important;
        min-height: 400px !important;
      }
    }

    .popover-tip-box {
      width: 100%;
      min-height: 300px;
      border-radius: 15px;
      .title {
        display: flex;
        width: 100%;
        font-size: 14px;
        color: #3c3c3c;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        background: linear-gradient(180deg, #ebf1fc, #fff);
        border-radius: 15px 15px 0 0;
        .s {
          span {
            color: #ee6360;
          }
          span.num {
            margin: 0 8px;
            font-size: 20px;
          }
        }
      }
      .cont-item {
        margin: 0 20px;
        padding: 10px 0;
        color: #3c3c3c;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .item-left {
          padding-left: 30px;
          .el-icon-document {
            margin-left: -30px;
          }
          .name {
            margin-left: 10px;
            font-weight: bold;
          }
          .yhj {
            margin-left: 5px;
            font-size: 12px;
            color: #b2b5ba;
            .num {
              margin-right: 5px;
              font-size: 14px;
              color: #3c3c3c;
            }
          }
        }
        .item-right {
          font-size: 12px;
          color: #b2b5ba;
          .color {
            font-size: 14px;
            color: #ee6360;
          }
          .i-num {
            font-size: 12px;
            font-style: italic;
            text-decoration: line-through;
          }
        }
      }
      .cont-item:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>
